import { Modal } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { useDeleteUser } from "@services/apiEcms/useDeleteUser";
import { CustomTrans } from "@utils/translations/CustomTrans";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { DeleteUserModalProps } from "./DeleteUserModal.types";

export const DeleteUserModal: FC<DeleteUserModalProps> = ({
  user,
  onClose,
  onDelete,
}) => {
  const { t } = useCustomTranslation("main");
  const { mutate, isPending } = useDeleteUser();
  const handleDeleteUser = () =>
    mutate(user.id, {
      onSuccess: () => {
        onDelete?.();
        onClose();
      },
    });

  return (
    <Modal maxSize="md" onClose={onClose}>
      <Modal.Header
        illustration="problem"
        title={t("userDetails.informations.delete.confirm.title")}
      />
      <Modal.Body>
        <CustomTrans
          i18nKey="userDetails.informations.delete.confirm.text"
          ns="main"
          parent="p"
          values={{ email: user.email }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.ConfirmButton
          isLoading={isPending}
          onClick={handleDeleteUser}
        >
          {t("userDetails.informations.delete.confirm.submit")}
        </Modal.Footer.ConfirmButton>
        <Modal.Footer.CancelButton>
          {t("userDetails.informations.delete.confirm.cancel")}
        </Modal.Footer.CancelButton>
      </Modal.Footer>
    </Modal>
  );
};
